/* 渲染顶部车的类型 */
import React from 'react'
import classnames from 'classnames'
import { sendTeaCommEvent } from 'lib/tea-analyze'
import Link from 'next/link'

interface ICarData {
  value: number | string
  text: string
}

export default function TypeList() {
  const carList = [
    {
      value: 0,
      text: '轿车',
    },
    {
      value: 1,
      text: 'SUV',
    },
    {
      value: 2,
      text: 'MPV',
    },
    {
      value: 4,
      text: '跑车',
    },
    {
      value: 3,
      text: '皮卡',
    },
    {
      value: 7,
      text: '微面',
    },
    {
      value: 8,
      text: '微卡',
    },
    {
      value: 6,
      text: '轻客',
    },
  ]

  /* 渲染车型的分类 */
  function renderCar(param: ICarData, index: number) {
    return (
      <Link
        href={`/auto/library/x-${param.value}-x-x-x-x-x-x-x-x-x`}
        key={param.value}
        as={`/auto/library/x-${param.value}-x-x-x-x-x-x-x-x-x`}
      >
        <a
          target="_blank"
          className={classnames('whole', 'fl')}
          onClick={() => {
            sendTeaCommEvent('click_home_top_series_type', {
              series_type: param.text,
              series_type_id: param.value,
            })
          }}
        >
          <div className="icon" />
          <style jsx>
            {`
              .whole {
                display: block;
                width: 149px;
                height: 100%;
              }
              .icon {
                width: 149px;
                height: 56px;
                background-repeat: no-repeat;
                cursor: pointer;
                background-image: url(${require('static/carType.png')});
                background-size: 1196px 112px;
                background-position: -${index * 149}px 0px;
              }
              .icon:hover {
                background-position: -${index * 149}px -56px;
              }
            `}
          </style>
        </a>
      </Link>
    )
  }

  return (
    <div className="list clearfix">
      {carList.map((item: ICarData, index: number) => renderCar(item, index))}
      <style jsx>
        {`
          .list {
            margin-top: 16px;
            margin-bottom: 16px;
            height: 56px;
          }
        `}
      </style>
    </div>
  )
}
